function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M451.47 49.25l-70.22.125-5.47-.03L373.064 54l-34.344 58.875-58.876.125-31.188-53.375-2.625-4.72-5.468-.06-70.218.124-5.5-.032-2.688 4.656-34 58.312-65.562.125-5.47-.03-2.718 4.656-35.093 60.188-2.688 4.656 2.78 4.688 31.126 53.28-33.75 57.938-2.718 4.656 2.782 4.688 35.125 60.094 2.593 4.75 5.5.03 67.812-.124 31.03 53.03 2.595 4.75 5.5.033 67.594-.125 31.187 53.375 2.626 4.718 5.47.064 70.218-.125 5.312.092 2.72-4.656 34.155-58.375 65.564-.124 5.312.094 2.688-4.656 35.28-60.25 2.688-4.656-2.78-4.688-35.126-60.094-2.594-4.72-5.5-.06-67.593.124-27.19-46.5 32.94-56.344 61.53-.125 5.313.095 2.687-4.656 35.25-60.25 2.72-4.657-2.783-4.688-35.125-60.094-2.593-4.718-5.5-.062zm-5.345 18.656l29.5 51.094-29.53 50.688-59.47.093L357 118.876l29.656-50.906 59.47-.064zM127.47 136.562l29.5 51.094-29.532 50.688-59.47.094-29.624-50.907L68 136.626l59.47-.063zm106.905 58l28.53 49.5-30.374 52.125-57.78.094-29.5-50.717 29.656-50.907 59.47-.094zm105.313 57.344l29.375 50.938-29.532 50.72-59.467.06-28.72-49.343L281.907 252l57.78-.094zm106.78 57.875l29.5 51.095-29.53 50.688-59.47.062-29.624-50.875L387 309.844l59.47-.063zm-214.53 5.19l29.406 50.967-29.53 50.688-59.47.063-29.625-50.907 29.56-50.717 59.657-.094z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubesIcon);
export default __webpack_public_path__ + "static/media/tubesIcon.920c58981f0117b4d54c24c19a683b46.svg";
export { ForwardRef as ReactComponent };